import { render, staticRenderFns } from "./initial.vue?vue&type=template&id=5576a79c&scoped=true&"
import script from "./initial.vue?vue&type=script&lang=js&"
export * from "./initial.vue?vue&type=script&lang=js&"
import style0 from "./initial.vue?vue&type=style&index=0&id=5576a79c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5576a79c",
  null
  
)

export default component.exports